<template>
   <div class="row">
      <div  class="col-md-12">
         <div class="form-inline" v-if="meta.is_active">
            <label class="mr-2">Filter Table</label>
            <select
               class="form-control ml-5"
               v-model="meta.is_active"
               @change="loadIsActive"
            >
               <option value="2">Show All</option>
               <option value="1">Show Only Active</option>
               <option value="0">Show Only Inactive</option>
            </select>
         </div>
         <div class="clearfix"><br /></div>
      </div>
      <div class="col-md-4 mb-2">
         <div class="form-inline">
            <label class="mr-2">Showing</label>
            <select
               class="form-control"
               v-model="meta.per_page"
               @change="loadPerPage"
            >
               <option value="10">10</option>
               <option value="25">25</option>
               <option value="50">50</option>
               <option value="100">100</option>
            </select>
            <label class="ml-2">Entries</label>
         </div>
      </div>

      <div class="col-md-4 offset-md-4">
         <!-- SEARCH BY DATE -->
         <div class="form-inline float-right" v-if="is_search_by_date">
            <label class="mr-2">Search by Date</label>
            <input type="date" class="form-control" @input="search" />
         </div>
         <!-- SEARCH DEFAULT -->
         <div class="form-inline float-right mb-3" v-else>
            <label class="mr-2">Search</label>
            <input type="text" class="form-control" @input="search" />
         </div>
      </div>

      <div class="col-md-12">
         <CDataTable
            sorter
            striped
            hover
            bordered
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            show-empty
         >
            <template #is_active="{item}">
               <td>
                  <CBadge v-if="item.is_active == 0" color="danger">No</CBadge>
                  <CBadge v-if="item.is_active == 1" color="success"
                     >Yes</CBadge
                  >
               </td>
            </template>

            <template #class_batch="{item}">
               <td v-if="item.class_batch == null">
                  <b> {{ "-" }} </b>
               </td>
               <td v-else>{{ item.class_batch.name }}</td>
            </template>

            <template #class_template="{item}">
               <td v-if="item.class_template == null">
                  <b> {{ "-" }} </b>
               </td>
               <td v-else>{{ item.class_template.name }}</td>
            </template>
            <template #class_schedule="{item}">
               <td v-if="item.class_schedule == null">
                  <b> {{ "-" }} </b>
               </td>
               <td v-else>{{ item.class_schedule.class_date }}</td>
            </template>
            <template #attend_date="{item}">
               <td v-if="item.attend_date == null">
                  <b> {{ "-" }} </b>
               </td>
               <td v-else>{{ item.attend_date }}</td>
            </template>
            <template #action="{item}">
               <td style="width:250px">
                  <CButton
                     size="sm"
                     variant="primary"
                     color="info"
                     class="ml-1"
                     @click="show(item.people_id)"
                     >Show</CButton
                  >
                  <CButton
                     size="sm"
                     variant="primary"
                     color="success"
                     class="ml-1"
                     @click="
                        attend(
                           item.people_id,
                           item.batch_id,
                           item.template_id,
                           item.schedule_id
                        )
                     "
                     >Attendance</CButton
                  >
               </td>
            </template>
         </CDataTable>
      </div>

      <div class="col-md-6">
         <p>
            Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items
         </p>
      </div>

      <div class="col-md-6">
         <b-pagination
            v-model="meta.current_page"
            :total-rows="meta.total"
            :per-page="meta.per_page"
            align="right"
            @change="changePage"
            aria-controls="dw-datatable"
         ></b-pagination>
      </div>
   </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import service from "@/services/service";
import axios from "axios";
import store from "@/store.js";

export default {
   name: "Table",
   props: {
      items: Array,
      caption: {
         type: String,
         default: "Table",
      },
      hover: Boolean,
      striped: Boolean,
      bordered: Boolean,
      small: Boolean,
      fixed: Boolean,
      dark: Boolean,
      items: {
         type: Array,
         required: true,
      },
      listbatch:{
         type: Array,
         required: true,
      },
      listtemplate:{
         type: Array,
         required: true,
      },
      fields: {
         type: Array,
         required: true,
      },
      meta: {
         required: true,
      },
      btn_show: {
         required: true,
      },
      btn_edit: {
         required: true,
      },
      btn_deactivate: {
         required: true,
      },
      btn_reactivate: {
         required: true,
      },
      btn_destroy: {
         required: true,
      },
      is_uuid: {
         required: true,
      },
      is_search_by_date: {
         required: true,
      },
   },
   data() {
      return {
         sortBy: null,
         sortDesc: false,
         deleteModal: false,
         selected: null,
         selectID: null,
         inc: 5,
      };
   },
   watch: {
      sortBy(val) {
         this.$emit("sort", {
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
         });
      },
      sortDesc(val) {
         this.$emit("sort", {
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
         });
      },
   },
   methods: {
      getPhoto(data) {
         if (data) {
            return axios.defaults.baseURL + "/getfile/memberphoto/" + data;
         } else {
            return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
         }
      },

      loadPerPage(val) {
         this.$emit("per_page", this.meta.per_page);
      },

      loadIsActive(val) {
         this.$emit("is_active", this.meta.is_active);
      },

      loadBatchFilter(val) {
          this.$emit('batch_filter', this.meta.batch)
      },

      loadTemplateFilter(val) {
          this.$emit('template_filter', this.meta.template)
      },

      changePage(val) {
         this.$emit("pagination", val);
      },

      search: _.debounce(function(e) {
         this.$emit("search", e.target.value);
      }, 500),

      openURL(data) {
         this.$router.push({
            path: "/member/member_detail",
            query: { Pud: data },
         });
      },

      show: function(id) {
         this.$emit("show", id);
      },
      attend: function(id, batch_id, template_id, schedule_id) {
         this.$emit("attend", id, batch_id, template_id, schedule_id);
      },

      //   resetpassword: function (id) {
      //     this.$emit('resetpassword', id)
      //   },

      //   grantwebaccess: function (id) {
      //     this.$emit('grantwebaccess', id)
      //   },

      //   converttomember: function (id) {
      //     this.$emit('converttomember', id)
      //   },

      frontEndDateFormat: function(date) {
         return moment(date, "YYYY-MM-DD").format("DD MMMM YYYY");
      },
   },
};
</script>
